<template>
  <v-flex d-flex xs6 sm3 md3 lg2 :title="product.name">
    <v-card @click.stop="openModal" style="cursor: pointer;" height="100%">
      <div class="soldout-tag" v-if="isOutOfStock">
        <div class="text">{{ $t("Sold Out") }}</div>
      </div>
      <template v-if="productImages && productImages.length >= 1">
        <v-responsive
          :aspect-ratio="1"
          style="background-position: center;background-size: cover;"
          :style="{
            backgroundImage:
              'url(\'' +
              productImages[0] +
              '\'),url(\'' +
              require('../../assets/img/products/default-photo.png') +
              '\')',
          }"
        >
          <!-- <div
            style="background-color: #eee;height: 100%;background-position: center;background-size: cover;"
            :style="{ backgroundImage: 'url(\'' + productImages[0] + '\'),url(\''+require('../../assets/img/products/default-photo.png')+'\')' }"
          ></div> -->
          <v-img
            v-if="productImages[0]"
            :src="productImages[0]"
            :lazy-src="`../../assets/img/products/default-photo.png`"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout> </template
          ></v-img>
        </v-responsive>
        <!-- <v-img :src="productImages[0]" aspect-ratio="1" :alt="product.name" lazy-src></v-img> -->
      </template>
      <div
        class="text-xs-center sale-tag caption"
        v-if="discountPercentage > 0"
        style="position: absolute; right: 5px; top: 0"
      >
        {{ $t("Sale") }}
        <br />
        {{ discountPercentage | numberFormat }}%
      </div>

      <v-card-title primary-title class="pt-3">
        <div>
          <div class="caption mb-2 mt-0">{{ product.name }}</div>
          <div class="body-1 mb-1" :style="{ color: theme.color }">
            <template v-if="discountPriceRange != priceRange">{{ discountPriceRange }}</template>
            <template v-else>{{ priceRange }}</template>
          </div>
          <div class="caption discount" v-if="discountPriceRange != priceRange">
            {{ priceRange }}
          </div>
          <div class="caption" v-else>&nbsp;</div>
        </div>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";

import $ from "jquery";
import config from "@/config";
import axios from "axios";
import ModalProduct from "@/components/ecommerce/ModalProduct.vue";
import Modal from "@/components/Modal.vue";
import ModalImage from "@/components/ModalImage.vue";
import numeral from "numeral";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import Nl2br from "vue-nl2br";
import { Carousel, Slide } from "vue-carousel";

import vZoom from "vue-zoom";
import { bearhousepackagehasbubble, bearhousebubbletea } from "@/assets/js/BearHouse.js";

export default {
  props: ["value", "products", "pageProfile"],
  data() {
    return {
      product: this.value,
      showModal: false,
      showAlert: false,
      showPreview: false,
      currentPreview: null,
      quantity: 1,
      stock: [],
      option: null,
      selectedImage: null,
      loadingProduct: true,
      productbundle: [],

      isImageFail: false,
    };
  },
  computed: {
    ...mapGetters({
      cart: "getCart",
      isWholesale: "getWholesaleStatus",
      wholesale: "getWholesale",
      theme: "getTheme",
    }),
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case "THB":
            return "฿";

          default:
            return "$";
        }
      }
      return "$";
    },
    productImages: function() {
      let images = [];
      if (this.product) {
        $.each(this.product.photourl.split(";;"), function(index, val) {
          images.push(val);
        });
        // this.previewImage =
        //   images.length > 0
        //     ? images[0]
        //     : "../assets/img/ecommerce/product_image_fallback@2x.png";
      }
      return images;
    },
    isOutOfStock: function() {
      let vm = this;
      if (vm.option) {
        if (parseInt(vm.option[2]) <= 0) {
          return true;
        }
        if (parseInt(vm.option[2]) < vm.quantity) {
          return true;
        }
        return false;
      }
      return true;
    },
    priceRange: function() {
      var min = 0;
      var max = 0;

      if (this.product.productstock.length <= 0) {
        min = this.product.price;
        max = this.product.price;
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][3];
            max = this.product.productstock[index][3];
          } else {
            if (this.product.productstock[index][3] > max) {
              max = this.product.productstock[index][3];
            }
            if (this.product.productstock[index][3] < min) {
              min = this.product.productstock[index][3];
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format("0,0.00");
      } else {
        return (
          this.currencySign +
          numeral(min).format("0,0.00") +
          " - " +
          this.currencySign +
          numeral(max).format("0,0.00")
        );
      }
    },
    discountPriceRange: function() {
      var min = 0;
      var max = 0;

      if (this.product.productstock.length <= 0) {
        min = this.product.discountprice;
        max = this.product.discountprice;
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][4];
            max = this.product.productstock[index][4];
          } else {
            if (this.product.productstock[index][4] > max) {
              max = this.product.productstock[index][4];
            }
            if (this.product.productstock[index][4] < min) {
              min = this.product.productstock[index][4];
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format("0,0.00");
      } else {
        return (
          this.currencySign +
          numeral(min).format("0,0.00") +
          " - " +
          this.currencySign +
          numeral(max).format("0,0.00")
        );
      }
    },
    discountPercentage: function() {
      var max = 0;

      if (this.product.productstock.length <= 0) {
        max = ((this.product.price - this.product.discountprice) / this.product.price) * 100;
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            max =
              ((this.product.productstock[index][3] - this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100;
          } else {
            var percent =
              ((this.product.productstock[index][3] - this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100;
            if (max < percent) {
              max = percent;
            }
          }
        }
      }

      return max;
    },
    totalBundle: function() {
      var vm = this;
      var quantity = 0;
      if (vm.isWholesale) {
        if (vm.cart) {
          vm.cart.map(function(product) {
            quantity += product.quantity;
          });
        }
        return quantity;
      }
      var products = vm.cart.filter(function(product) {
        return product.id == vm.product.id;
      });
      quantity = 0;
      products.map((p) => {
        quantity += p.quantity;
      });
      return quantity;
    },
    productstock: function() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.product.productstock;
      // .sort(function(a, b) {
      //   if (a[6] > b[6]) {
      //     return 1;
      //   } else if (a[6] < b[6]) {
      //     return -1;
      //   } else {
      //     return 0;
      //   }
      // });
    },
    isBearhouse() {
      return this.pageProfile && this.$store.state.bearhouse.includes(this.pageProfile.pageid);
    },
    bubbletea() {
      return bearhousebubbletea(this.products);
    },
    hasBubbleTea() {
      return bearhousepackagehasbubble().includes(this.product.id);
    },
  },
  components: {
    vZoom,
    ModalProduct,
    Modal,
    ModalImage,
    VueperSlides,
    VueperSlide,
    Nl2br,
    Carousel,
    Slide,
  },
  watch: {
    value: function() {
      let vm = this;
      this.product = this.value;
      //   this.getStock()
      if (this.productImages.length > 0) {
        this.selectedImage = this.productImages[0];
      }

      vm.setOption();
    },
    showModal: function(newVal) {
      if (newVal) {
        $("body").addClass("modal-open");
      } else {
        $("body").removeClass("modal-open");
      }
    },
  },
  created: function() {},
  mounted: function() {
    // this.getStock()
    let vm = this;
    if (this.productImages.length > 0) {
      this.selectedImage = this.productImages[0];
    }

    if (this.$route.query.pid) {
      var pid = this.$route.query.pid;
      var productid = pid;
      // console.log(productid, this.product.id.toString());
      if (productid === this.product.id.toString()) this.openModal();
    }
    vm.setOption();

    vm.loadingProduct = false;
  },
  methods: {
    getProductBundle: function(callback) {
      let vm = this;
      let url = config.getConfig("serverUrl") + "productbundle?productid=" + vm.product.id;
      axios.get(url).then((response) => {
        response = response.data;
        if (response.responsecode == 200) {
          vm.productbundle = response.productbundlelist;
          callback();
        } else {
          callback();
        }
      });
    },
    onPreviewImgError: function() {
      this.isImageFail = true;
      //  this.previewImage = "../assets/img/ecommerce/product_image_fallback@2x.png"
    },
    setOption: function() {
      let vm = this;
      if (vm.product && vm.product.productstock && vm.product.productstock.length > 0) {
        vm.option = null;
        $.each(vm.productstock, function(index, val) {
          if (parseInt(val[2]) > 0) {
            vm.option = val;
            return false;
          }
        });
      } else {
        vm.option = null;
      }
    },
    openModal: function() {
      this.$emit("selectProduct");
      // this.showModal = true;
      // // eslint-disable-next-line
      // let vm = this;
      // vm.getProductBundle(function() {});
      // window.location.hash = "#modal-open";
      // window.onpopstate = function() {
      //   if (location.hash != "#modal-open") {
      //     vm.showModal = false;
      //   }
      // };
    },
    close: function() {
      let vm = this;
      if (window.history.length == 0) {
        vm.showModal = false;
      } else {
        window.history.back();
      }
    },
    addCount: function() {
      if (!this.option || this.option == null) {
        return false;
      }
      if (this.quantity < this.option[2]) {
        this.quantity++;
      }
    },
    removeCount: function() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    addToCart: function() {
      let vm = this;
      // if (vm.cart.length >= 10) {
      //   vm.showAlert = true;
      //   return false;
      // }
      if (vm.isOutOfStock) {
        return false;
      }

      var price = vm.option[3];
      var discountprice = vm.option[4];
      let item = {
        quantity: vm.quantity,
        option: vm.option,
        buttonaction: vm.product.buttonaction,
        buttonname: vm.product.buttonname,
        buttonurl: vm.product.buttonurl,
        categoryid: vm.product.categoryid,
        currency: vm.product.currency,
        description: vm.product.description,
        id: vm.product.id,
        keyword: vm.product.keyword,
        name: vm.product.name,
        pageid: vm.product.pageid,
        photohash: vm.product.photohash,
        photourl: vm.product.photourl,
        price: price,
        priority: vm.product.priority,
        subcategoryid: vm.product.subcategoryid,
        discountprice: discountprice,
        productbundle: vm.productbundle,
      };
      vm.setOption();

      vm.quantity = 1;
      vm.$emit("addToCart", item);
      vm.close();
    },
    getStock: function() {
      let vm = this;
      axios
        .get(config.getConfig("serverUrl") + "productstock?productid=" + vm.product.id)
        .then((response) => {
          // JSON responses are automatically parsed.
          response = response.data;
          if (response.responsecode == 200) {
            vm.stock = response.productstocklist;
            vm.setOption();
          } else {
            // console.log(response);
          }
        });
    },
  },
};
</script>

<style scoped></style>
